export default [
  ["A", "A", "B", "C", "C", "D"],
  ["A", "B", "C", "C", "E", "E"],
  ["B", "C", "C", "D", "E", "F"],
  ["C", "C", "D", "E", "F", "F"],
  ["C", "E", "E", "F", "F", "F"],
  ["D", "E", "F", "F", "F", "G"],
] as const;
